import { lazy } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'

import { SuspensedView } from '@components/SuspensedView'

import { MasterLayout } from '@/layouts/MasterLayout'

const SummaryReportRoutes = lazy(() => import('@/routes/cluster-manager/SummaryReportRoutes'))

const ClusterManagerRoutes = () => {
  return (
    <Routes>
      <Route element={<MasterLayout />}>
        <Route
          path="summary-report/*"
          element={
            <SuspensedView>
              <SummaryReportRoutes />
            </SuspensedView>
          }
        />

        <Route
          path="*"
          element={<Navigate to="/error/404" />}
        />
      </Route>
    </Routes>
  )
}

export { ClusterManagerRoutes }
